export const getWorkflowInstanceName = (workflow: string, id: string) =>
  `workflows/${workflow}/instances/${id}`;

export const getIsEditDisabled =
  (disabledStates: string[]) =>
  (
    workflowInstance?: Maybe<{
      state: string;
      lockedDataKeys: string[];
    }>,
    key?: string,
  ) =>
    Boolean(
      (workflowInstance && disabledStates.includes(workflowInstance.state)) ||
        (key !== undefined && workflowInstance?.lockedDataKeys?.includes(key)),
    );

type WorkflowStateHistory = {
  state: string;
  stateHistory?: Array<{ state?: string | null }> | null;
};

export const hasWorkflowHadState = (
  workflowInstance: WorkflowStateHistory,
  states: readonly string[],
): boolean =>
  states.includes(workflowInstance.state) ||
  Boolean(
    workflowInstance.stateHistory?.some(({ state }) =>
      states.includes(state ?? ''),
    ),
  );

export const getHasWorkflowLaunched = (
  workflowInstance: WorkflowStateHistory,
): boolean =>
  workflowInstance.state !== 'draft' &&
  hasWorkflowHadState(workflowInstance, ['live']);
